import { IVersion } from "@logex/framework/lg-application";

export interface Scenario extends IVersion {
    data_version: number;
    scenario_version: number;
    user_version: number;

    ziekenhuiscode: number;

    created_by: string;
    parent_version_id?: number;
    deleted?: string;
    user_deleted?: string;
    is_default: boolean;

    data_version_comment: string;
    data_version_naam: string;
    scenario_naam: string;
    scenario_omschrijving: string;
    jaar: number;
    periode: number;
    settings: AppVersionSettings;
}

export interface AppVersionSettings {
    hospital_abbreviation: string;
    is_practice_variation_enabled: boolean;
    enable_practice_variation_activity_popup: boolean;
    enable_ac_level_magnifying_glass: boolean;
    is_rve_filtering_available: boolean;
    is_local_reference_left: boolean;
    is_servicearea_available: boolean;
}
